<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div> 

<!-- {{cs_id}} - {{pond_id}} -->

<div  class="field">
  <div class="control">

<!-- <slot name="note"></slot> -->

    <input :disabled="enabled" v-model="student_note" @change="mod_note()" min="0" 
      class="input is-fullwidth has-text-centered has-text-weight-bold" type="number" 
      placeholder="note" value="">
  </div>
</div>


</div>
</template>

<script>
import axios from 'axios';

export default {
        // props: [ 'note', 'n_id', 'pond_id', 'cs_id', 'enabled' ],
        // props: [ 'note','enabled','pond_index','key_index'],
        props: [ 'note','enabled','pond_id','cs_id'],
        components: {  },

        data() {
            return {
                isLoading:false,

                 student_note: this.note, //Math.round(this.note),
                //  note_id:this.n_id,
            }
        },

created() {

},


methods : {





get_note:function(studID) {

  var indx = this.notes.findIndex(x => x.stud_id == studID);
  if (indx > -1) 
  {return }

},

mod_note:function() {
  // this.$emit('emit_note_update', this.student_note, this.pond_index, this.key_index);
  this.$emit('emit_note_update', this.student_note, this.pond_id, this.cs_id);
},



}, // END METHODS


}
</script>